const constants = {
  BLACKLIST_FETCH_START: 'BLACKLIST_FETCH_START',
  BLACKLIST_FETCH_END: 'BLACKLIST_FETCH_END',
  BLACKLIST_DELETE_START: 'BLACKLIST_DELETE_START',
  BLACKLIST_DELETE_END: 'BLACKLIST_DELETE_END',
  BLACKLIST_UPDATE_START: 'BLACKLIST_UPDATE_START',
  BLACKLIST_UPDATE_END: 'BLACKLIST_UPDATE_END',
  BLACKLIST_SHOW_HIDE_VARIABLES: 'BLACKLIST_SHOW_HIDE_VARIABLES',
  BLACKLIST_CHANGE_VARIABLE: 'BLACKLIST_CHANGE_VARIABLE',
};

export default constants;
